import React, { useState, useRef } from 'react'; 
import './Schools.css';

const schoolsList = [
  { id: 1, name: "Adamson University", logo: "pics/LogoSchools/adamson university.png" },
  { id: 2, name: "Adventist University of the Philippines", logo: "pics/LogoSchools/adventist university of the philippines.png" },
  { id: 3, name: "Aemilianum College Inc.", logo: "pics/LogoSchools/aemilianum college inc.png" },
  { id: 4, name: "Agusan del Sur State Colleges of Agriculture and Technology", logo: "pics/LogoSchools/agusan del sur state college of agriculture and technology.png" },
  { id: 5, name: "AMA Computer College - Calamba", logo: "pics/LogoSchools/ama calamba.png" },
  { id: 6, name: "AMA University – Quezon City", logo: "pics/LogoSchools/ama university.png" },
  { id: 7, name: "Angeles University Foundation", logo: "pics/LogoSchools/angeles university foundation.png" },
  { id: 8, name: "Asia Pacific College", logo: "pics/LogoSchools/asia pacific college.png" },
  { id: 9, name: "Ateneo de Davao University", logo: "pics/LogoSchools/ateneo de davao.png" },
  { id: 10, name: "Ateneo de Naga University", logo: "pics/LogoSchools/ateneo de naga.png" },
  { id: 11, name: "Ateneo de Zamboanga University", logo: "pics/LogoSchools/ateneo de zamboanga.png" },
  { id: 12, name: "Bataan Heroes College", logo: "pics/LogoSchools/bataan heroes college.png" },
  { id: 13, name: "Bataan Peninsula State University", logo: "pics/LogoSchools/bataan peninsula.png" },
  { id: 14, name: "Batangas State University The NEU - Alangilan", logo: "pics/LogoSchools/batangas state university.png"},
  { id: 15, name: "Bicol State College of Applied Sciences and Technology", logo: "pics/LogoSchools/bicol state college.png" },  
  { id: 16, name: "Bicol University Polangui Campus", logo: "pics/LogoSchools/bicol university.png" },
  { id: 17, name: "Bulacan State University", logo: "pics/LogoSchools/bulacan state university.png" },
  { id: 18, name: "Cagayan State University", logo: "pics/LogoSchools/cagayan state university.png" },  
  { id: 19, name: "Cagayan Valley Computer and Information Technology College", logo: "pics/LogoSchools/cagayan valley computer.png" },  
  { id: 20, name: "Camarines Sur Polytechnic Colleges", logo: "pics/LogoSchools/camarines sur polytechnic colleges.png" },
  { id: 21, name: "Camiguin Polytechnic State College", logo: "pics/LogoSchools/camiguin polytechnic state college.png" },
  { id: 22, name: "Caraga State University", logo: "pics/LogoSchools/caraga state university.png" },
  { id: 23, name: "Carlos Hilado Memorial State University", logo: "pics/LogoSchools/carlos hilado memorial state university main - alijis.png" },
  { id: 24, name: "Catanduanes State University", logo: "pics/LogoSchools/catanduanes state university.png" },
  { id: 25, name: "Cavite State University – Indang", logo: "pics/LogoSchools/cavite state university.png"  },
  { id: 26, name: "Cebu Institute of Technology - University", logo: "pics/LogoSchools/cebu institute of technology - university.png" },
  { id: 27, name: "Cebu Technological University", logo: "pics/LogoSchools/cebu technological university.png" },
  { id: 28, name: "Central Philippine University", logo: "pics/LogoSchools/central philippine university.png" },
  { id: 29, name: "Colegio De Muntinlupa", logo: "pics/LogoSchools/colegio de muntinlupa.png" },
  { id: 30, name: "Colegio de San Gabriel Arcangel", logo: "pics/LogoSchools/colegio de san gabriel arcangel.png" },
  { id: 31, name: "Colegio de San Juan de Letran - Manila", logo: "pics/LogoSchools/colegio de san juan de letran - manila and calamba.png" },
  { id: 32, name: "Colegio de San Juan de Letran - Calamba", logo: "pics/LogoSchools/colegio de san juan de letran - manila and calamba.png"  },
  { id: 33, name: "Colegio San Agustin - Bacolod", logo: "pics/LogoSchools/colegio san agustin.png"  },
  { id: 34, name: "Columban College", logo: "pics/LogoSchools/columban college.png"  },
  { id: 35, name: "Computer Arts Technological College, Inc.", logo: "pics/LogoSchools/computer arts technological college.png" },
  { id: 36, name: "Cor Jesu College", logo: "pics/LogoSchools/cor jesu college.png"  },
  { id: 37, name: "De La Salle Lipa", logo: "pics/LogoSchools/de la salle lipa.png" },
  { id: 38, name: "De La Salle University - Manila", logo: "pics/LogoSchools/De Lasalle University.png"  },
  { id: 39, name: "De La Salle University - Dasmarinas", logo: "pics/LogoSchools/de la salle dasmarinas.png"  },
  { id: 40, name: "Divine Word College of Calapan", logo: "pics/LogoSchools/divine word college of calapan.png" },
  { id: 41, name: "Don Bosco Technical Colleges", logo: "pics/LogoSchools/don bosco technical college.png"  },
  { id: 42, name: "Don Honorio Ventura State University", logo: "pics/LogoSchools/don honorio ventura state university.png" },
  { id: 43, name: "Eastern Visayas State University", logo: "pics/LogoSchools/Eastern Visayas State University.png" },
  { id: 44, name: "Emilio Aguinaldo College in Cavite", logo: "pics/LogoSchools/Emilio_Aguinaldo_College_seal.png"  },
  { id: 45, name: "Eulogio “Amang” Rodriguez Institute of Science and Technology", logo: "pics/LogoSchools/Eulogio \"Amang\" Rodriguez Institute of Science and Technology.png"  },
  { id: 46, name: "Eulogio “Amang” Rodriguez Institute of Science and Technology - Cavite", logo: "pics/LogoSchools/Eulogio \"Amang\" Rodriguez Institute of Science and Technology.png"  },
  { id: 47, name: "Far Eastern University - Alabang", logo: "pics/LogoSchools/FEU_Alabang_logo.png"  },
  { id: 48, name: "Far Eastern University - Institute of Technology", logo: "pics/LogoSchools/FEU_Tech_official_seal.png"  },
  { id: 49, name: "Fellowship Baptist College", logo: "pics/LogoSchools/Fellowship Baptist College.png"  },
  { id: 50, name: "Filamer Christian University", logo: "pics/LogoSchools/Filamer_Christian_University,_Inc..png"  },
  { id: 51, name: "First Asia Institute of Technology and Humanities Colleges", logo: "pics/LogoSchools/FAITH-Colleges-Logo.png"  },
  { id: 52, name: "Full Bright College", logo: "pics/LogoSchools/Full_Bright_Colleges.png"  },
  { id: 53, name: "Holy Angel University", logo: "pics/LogoSchools/Holy_Angel_University.png"  },
  { id: 54, name: "Holy Cross of Davao College", logo: "pics/LogoSchools/hcdc_logo.png"  },
  { id: 55, name: "ICCT Colleges Foundation Inc.", logo: "pics/LogoSchools/icct.png"  },
  { id: 56, name: "Iloilo Science and Technology University", logo: "pics/LogoSchools/ISTU.png"  },
  { id: 57, name: "Jose Rizal University", logo: "pics/LogoSchools/Jose_Rizal_University_seal.png"  },
  { id: 58, name: "Laguna State Polytechnic University - San Pablo", logo: "pics/LogoSchools/LSPU.png"  },
  { id: 59, name: "Laguna State Polytechnic University - Sta. Cruz", logo: "pics/LogoSchools/LSPU.png"  },
  { id: 60, name: "Lyceum- Northwestern University", logo: "pics/LogoSchools/LYCEUM-NU.png"  },
  { id: 61, name: "Lyceum of the Philippines University – Laguna", logo: "pics/LogoSchools/Lyceum_of_the_Philippines_University.png"  },
  { id: 62, name: "Lyceum of the Philippines University - Cavite", logo: "pics/LogoSchools/Lyceum_of_the_Philippines_University.png"  },
  { id: 63, name: "Manuel S. Enverga University Foundation" },
  { id: 64, name: "Mapua Malayan Colleges Laguna" },
  { id: 65, name: "Mapúa Malayan Colleges Mindanao" },
  { id: 66, name: "Mapúa University" },
  { id: 67, name: "Mariano Marcos State University" },
  { id: 68, name: "Marikina Polytechnic College" },
  { id: 69, name: "Marinduque State University" },
  { id: 70, name: "Mindanao State University - General Santos City" },
  { id: 71, name: "Mindanao State University - Iligan Institute of Technology" },
  { id: 72, name: "Mindanao State University - Main" },
  { id: 73, name: "Mindoro State University – Calapan City" },
  { id: 74, name: "National College of Science and Technology" },
  { id: 75, name: "National University - Manila" },
  { id: 76, name: "New Era University" },
  { id: 77, name: "Northwest Samar State University" },
  { id: 78, name: "Notre Dame of Dadiangas University" },
  { id: 79, name: "Notre Dame of Kidapawan College" },
  { id: 80, name: "Notre Dame of Marbel University" },
  { id: 81, name: "Notre Dame of Midsayap College" },
  { id: 82, name: "Notre Dame University" },
  { id: 83, name: "Nueva Vizcaya State University" },
  { id: 84, name: "Our Lady of Fatima University – Quezon City" },
  { id: 85, name: "Pamantasan ng Cabuyao" },
  { id: 86, name: "Pamantasan ng Lungsod ng Maynila" },
  { id: 87, name: "Pamantasan ng Lungsod ng Pasig" },
  { id: 88, name: "PHINMA University of Pangasinan" },
  { id: 89, name: "Polytechnic University of the Philippines - Manila" },
  { id: 90, name: "Polytechnic University of the Philippines - Sto. Tomas Campus" },
  { id: 91, name: "Polytechnic University of the Philippines - Taguig" },
  { id: 92, name: "Polytechnic University of the Philippines – Maragondon Campus" },
  { id: 93, name: "Polytechnic University of the Philippines - Santa Rosa Campus" },
  { id: 94, name: "Quezon City University" },
  { id: 95, name: "Rizal Technological University" },
  { id: 96, name: "Rogationist College" },
  { id: 97, name: "Saint Louis University" },
  { id: 98, name: "Samar State University" },
  { id: 99, name: "San Sebastian College Recoletos de Cavite" },
  { id: 100, name: "Sorsogon State University" },
  { id: 101, name: "Southern Luzon State University" },
  { id: 102, name: "St. Peter’s College" },
  { id: 103, name: "STI West Negros University" },
  { id: 104, name: "Sultan Kudarat State University" },
  { id: 105, name: "Surigao del Norte State University" },
  { id: 106, name: "Surigao Education Center" },
  { id: 107, name: "Systems Plus College Foundation" },
  { id: 108, name: "Tarlac State University" },
  { id: 109, name: "Technological Institute of the Philippines - Manila" },
  { id: 110, name: "Technological Institute of the Philippines – Quezon City" },
  { id: 111, name: "Technological University of the Philippines - Taguig" },
  { id: 112, name: "Technological University of The Philippines - Visayas" },
  { id: 113, name: "Universal College of Paranaque" },
  { id: 114, name: "Universidad de Dagupan" },
  { id: 115, name: "Universidad De Manila" },
  { id: 116, name: "Universidad de Zamboanga" },
  { id: 117, name: "University of Antique" },
  { id: 118, name: "University of Baguio" },
  { id: 119, name: "University of Cebu - Banilad" },
  { id: 120, name: "University of Cebu - Lapu Lapu Mandaue" },
  { id: 121, name: "University of Cebu - Main" },
  { id: 122, name: "University of La Sallete" },
  { id: 123, name: "University of Luzon" },
  { id: 124, name: "University of Mindanao - Main" },
  { id: 125, name: "University of Mindanao Tagum College" },
  { id: 126, name: "University of Negros Occidental - Recoletos" },
  { id: 127, name: "University of Nueva Caceres" },
  { id: 128, name: "University of Perpetual Help System DALTA - Calamba" },
  { id: 129, name: "University of Perpetual Help System Dalta – Las Piñas" },
  { id: 130, name: "University of Perpetual Help System DALTA – Molino Campus" },
  { id: 131, name: "University of Perpetual Help System Laguna - Binan" },
  { id: 132, name: "University of Rizal System - Morong" },
  { id: 133, name: "University of Saint La Salle" },
  { id: 134, name: "University of Saint Louis" },
  { id: 135, name: "University of San Agustin" },
  { id: 136, name: "University of San Carlos" },
  { id: 137, name: "University of San Jose" },
  { id: 138, name: "University of Santo Tomas" },
  { id: 139, name: "University of Science and Technology of Southern Philippines" },
  { id: 140, name: "University of Southeastern Philippines - Obrero" },
  { id: 141, name: "University of Southern Mindanao" },
  { id: 142, name: "University of the Cordilleras" },
  { id: 143, name: "University of the East – Caloocan" },
  { id: 144, name: "University of the Immaculate Conception" },
  { id: 145, name: "University of the Philippines – Diliman" },
  { id: 146, name: "Urdaneta City University" },
  { id: 147, name: "Virgen Milagrosa University Foundation" },
  { id: 148, name: "Wesleyan University - Philippines" },
  { id: 149, name: "Western Mindanao State University" },
  { id: 150, name: "Westmead International School" }
];

const Schools = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const scrollRef = useRef(null);
  const [scrollProgress, setScrollProgress] = useState(0);

  const filteredSchools = schoolsList.filter((school) =>
    school.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleScroll = () => {
    if (scrollRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
      const progress = (scrollLeft / (scrollWidth - clientWidth)) * 100;
      setScrollProgress(progress || 0); // Ensures it starts at 0
    }
  };

  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = 600; 
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className="schools-page">
      <section className="schools-header-section">
        <h1 className="title">
          <span className="green">PARTICIPATING </span>
          <span className="white">SCHOOLS</span>
        </h1>
        <div className="mech-divider"></div>
        
        <div className="search-container">
          <input
            type="text"
            placeholder="Search for your university..."
            className="school-search-input"
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </section>

      <div className="matrix-navigation-container">
        <button className="nav-arrow left" onClick={() => scroll('left')}>&#10094;</button>

        <div className="matrix-scroll-wrapper" ref={scrollRef} onScroll={handleScroll}>
          <div className="matrix-grid">
            {filteredSchools.map((school) => (
              <div key={school.id} className="school-card-matrix">
                <div className="school-logo-frame">
                  <img src={school.logo || "pics/bnt.png"} alt={school.name} />
                </div>
                <div className="school-info"><p>{school.name}</p></div>
              </div>
            ))}
          </div>
        </div>

        <button className="nav-arrow right" onClick={() => scroll('right')}>&#10095;</button>
      </div>

      {/* --- BROUGHT BACK PROGRESS BAR --- */}
      <div className="scroll-indicator-container">
        <div className="progress-bar-bg">
          <div className="progress-bar-fill" style={{ width: `${scrollProgress}%` }}></div>
        </div>
        <p className="scroll-hint">Scroll to explore 150+ schools</p>
      </div>
    </div>
  );
};

export default Schools;